import { inject, Injectable } from '@angular/core';

import { LoginUser, SignUpUser, UserSession } from '../interface/user.interface';
import { Router } from '@angular/router';
import { HelperService } from './helper.service';
import { SupabaseClientService } from './supabase-client.service';
import { CookieService } from './cookie.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  currentUserSession: UserSession| null = null;
  
  supabaseService = inject(SupabaseClientService);
  helperService = inject(HelperService);
  cookieService = inject(CookieService);
  SUPABASE_APP_URL = environment.SUPABASE_APP_URL;

  constructor(private router: Router) {}

  async signUp(signUpForm:SignUpUser){
    const {data, error} = await this.supabaseService.client.auth.signUp({
      email: signUpForm.email,
      password: signUpForm.password,
      options:{captchaToken:signUpForm.captcha,emailRedirectTo: `${this.SUPABASE_APP_URL}/auth/login`}
    })

    if(data.user?.identities?.length) {
      this.helperService.authSnakBar.next('Signup successfull, Verify email')
      this.navigateHandler('/auth/login')
      return 'success'
    }
    if(data.user?.identities?.length == 0) {
      this.helperService.authSnakBar.next('Account already exist, Try login')
      return 'exist'
    }
    if(error) {
      throw(error.message)
    }
    return
  }

  async login(loginForm: LoginUser){
    try{
      const {data, error} = await this.supabaseService.client.auth.signInWithPassword({
        email:loginForm.email,
        password: loginForm.password,
        options:{captchaToken:loginForm.captcha}
      })
      if(error) throw(error.message)
      if(data.user) {
        this.currentUserSession = data.session as UserSession;
        this.navigateHandler('/dashboard/')
        return 'success'
      }
      throw('User not exist.')
    } catch(error){
      console.log("Error at login", error);
      throw(error)
    }
  }

  async getCurrectUserSession(){
    if(this.currentUserSession) return this.currentUserSession
    const {data, error} = await this.supabaseService.client.auth.getSession()
    //console.log("User Session Exists", data, error);
    
    if (error) return null
    this.currentUserSession = data.session as UserSession;
    return this.currentUserSession
  }

  async logout(){
    try {
      const {error} = await this.supabaseService.client.auth.signOut()
      this.currentUserSession = null;
      this.cookieService.deleteCookie('selectedCompanyId');
      if(error) throw error.message
      this.navigateHandler('/auth/login')
      window.location.reload(); // clear things stored on services like userData, companyUserData etc
      return 'success'
    }catch(error:any){
      console.log("Logout Error", error);
      if(error.includes('Auth session missing!')) {
        this.supabaseService.client.auth.refreshSession()//When there is no session bacause of the multiple login, the session will be refreshsed when first click and second click it will logout
      } 
      throw(error)
    }
  }

  async sendResetPasswordLink(email:string,captcha:string):Promise<string>{
    try {
      const {data, error} = await this.supabaseService.client
      .auth
      .resetPasswordForEmail(
        email,
        {redirectTo:`${this.SUPABASE_APP_URL}/reset_password`,captchaToken:captcha}
      )
      if(error) throw error
      return 'success'
    } catch(err:any){
      console.log("Error Reseting Password",err);
      return err.message ?? 'Failed sending reset password link'
    }
  } 

  async updateUserPassword(newPassword: string){
    try {
      const {data, error} = await this.supabaseService.client.auth
      .updateUser({password:newPassword})
      //console.log(data, error);
      if(error) throw error
      return 'success'
    } catch(err:any) {
      console.log("Error updating password", err);
      return err.message ?? 'error updating password'
    }
  }

  navigateHandler(path:string){
    this.router.navigate([`${path}`])
  }
}